import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export const useCourseStore = create()(
  persist(
    (set, get) => ({
      course: get()?.course || {},
      setCourse: (course) => set({ course }),
    }),
    {
      name: 'gsk-course',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
